import {
    Grid,
    Table,
    TableHead,
    TableRow,
    TableCell,
    Typography,
    TableBody,
  } from "@material-ui/core";
  import React, { FunctionComponent } from "react";
  import { financialItemStyles } from "./financialItemStyle";
  import TableContainer from "@material-ui/core/TableContainer";
  import "../Print.css";
  type DenominationDataProps = {
    denominationData: Array<object>;
    denominationTotal: number;
  };
  
  export const Denomination: FunctionComponent<DenominationDataProps> = ({
    denominationData,
    denominationTotal,
  }) => {
    const classes = financialItemStyles();
    return (
      <Grid container>
        <Grid item xs={12}>
          <TableContainer>
            <Table
              className={classes.table}
              size="small"
              aria-label="a dense table"
            >
              <TableHead className={classes.tableRow}>
                <TableRow style={{ height: "3em" }}>
                  <TableCell
                    align="left"
                    className={classes.headColor}
                    component="th"
                    scope="row"
                  >
                 Type
                  </TableCell>
                  <TableCell
                    align="center"
                    className={classes.headColor}
                    component="th"
                    scope="row"
                  >
                    Number of Transaction
                  </TableCell>
                  <TableCell align="right" className={classes.headColor}>
                    Total Amount
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {denominationData &&
                  denominationData.map((data: any) => (
                    <TableRow>
                      <TableCell align="left" className={classes.headColor}>
                        {data.denomination_code}
                      </TableCell>
                      <TableCell align="left" className={classes.tableColumn}>
                        {data.denomination_count}
                      </TableCell>
                      <TableCell align="right" className={classes.columnWeight}>
                        {data.denomination_amount}
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow style={{ height: "3em" }}>
                  <TableCell align="left" className={classes.totalCellStyle}>
                    <Typography className={classes.total}>Total</Typography>
                  </TableCell>
                  <TableCell align="left" className={classes.middleTotalcell} />
                  <TableCell align="right" className={classes.totalValueCell}>
                    <Typography className={classes.value}>
                    {denominationTotal}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    );
  };
  
  